import { graphql } from 'gatsby';
import { VideoPlayer, Heading } from 'lucid-components-react';
import React from 'react';

import { Drupal_ParagraphNineteenArticle } from '../../../generated/graphql';
import { getProcessedValue } from '../../../utils/helpers';
import './nineteen-article.scss';

interface Props {
  entity: Drupal_ParagraphNineteenArticle;
}

const NineteenArticle = ({
  entity: {
    fieldHeading,
    fieldImage,
    fieldBody,
    fieldMirror,
    fieldAltText,
    fieldVideoLink,
    fieldAutoplay
  }
}: Props) => {
  return (
    <section
      className={`nineteen-article  ${
        fieldMirror ? 'nineteen-article--mirrored' : ''
      }${fieldVideoLink ? 'nineteen-article--video' : ''}`}
    >
      <div className="lucid-container  nineteen-article__wrapper">
        <div className="nineteen-article__image">
          {fieldVideoLink ? (
            <VideoPlayer
              controls
              playing={!fieldAutoplay || false}
              url={fieldVideoLink}
              className="nineteen-article__video"
              placeholder={() => (
                <img src={fieldImage!} alt={fieldAltText || ''} />
              )}
            />
          ) : (
            <img src={fieldImage!} alt={fieldAltText || ''} />
          )}
        </div>
        <div className="nineteen-article__body">
          <Heading
            as="h2"
            mb={{ default: 4, mobile: 5, tablet: 4 }}
            variant="subheadS"
          >
            {fieldHeading}
          </Heading>
          <div
            className="nineteen-article__user-content"
            dangerouslySetInnerHTML={{ __html: getProcessedValue(fieldBody) }}
          />
        </div>
      </div>
    </section>
  );
};

export default NineteenArticle;

export const query = graphql`
  fragment nineteenArticle on Drupal_ParagraphNineteenArticle {
    entityId
    fieldBody {
      processed
    }
    fieldHeading
    fieldSubheader
    fieldVideoLink
    fieldAutoplay
    fieldMirror
    fieldImage
    fieldAltText
    fieldBeaconElementDetail
    fieldNineteenCtas {
      entity {
        ...nineteenCta
      }
    }
  }
`;
